"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseBtn = exports.ModalContent = exports.ModalSuccessMessage = exports.ModalSuccessIcon = exports.ModalActions = exports.Spacing = exports.ModalDescription = exports.ModalTitle = exports.StyleBase = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyleBase = _styledComponents["default"].div.withConfig({
  displayName: "StyleBase",
  componentId: "sc-19910cc-0"
})(["position:fixed;height:100%;width:100%;background-color:rgba(0,0,0,0.8);z-index:99;top:0;overflow-y:scroll;.modal-appear{opacity:0.01;}.modal-appear > div{opacity:0;}.modal-appear.modal-appear-active{opacity:1;transition:opacity 150ms ease;}"]);

exports.StyleBase = StyleBase;

var ModalTitle = _styledComponents["default"].div.withConfig({
  displayName: "ModalTitle",
  componentId: "sc-19910cc-1"
})(["display:flex;align-items:center;justify-content:flex-start;margin-bottom:5%;span:first-of-type{width:2%;}.title{font-family:Roboto;font-style:normal;font-weight:500;font-size:18px;", ";}"], function (props) {
  return props.titleColor ? "color: ".concat(props.titleColor) : "color: #E23943";
});

exports.ModalTitle = ModalTitle;

var ModalDescription = _styledComponents["default"].div.withConfig({
  displayName: "ModalDescription",
  componentId: "sc-19910cc-2"
})(["", ";margin-bottom:5%;.description{font-family:Roboto;font-style:normal;font-weight:normal;", ";color:#212121;margin-bottom:3%;}.hint{font-family:Roboto;font-style:normal;font-weight:normal;font-size:14px;color:#858585;}"], function (props) {
  return props.descriptionPadding ? "padding: 0 ".concat(props.descriptionPadding, "%") : "padding: 0";
}, function (props) {
  return props.descriptionFontSize ? "font-size: ".concat(props.descriptionFontSize, "px") : "font-size: 18px";
});

exports.ModalDescription = ModalDescription;

var Spacing = _styledComponents["default"].span.withConfig({
  displayName: "Spacing",
  componentId: "sc-19910cc-3"
})(["", ";"], function (props) {
  return props.width ? "width: ".concat(props.width, "px") : null;
});

exports.Spacing = Spacing;

var ModalActions = _styledComponents["default"].div.withConfig({
  displayName: "ModalActions",
  componentId: "sc-19910cc-4"
})(["display:flex;justify-content:flex-end;align-items:center;"]);

exports.ModalActions = ModalActions;

var ModalSuccessIcon = _styledComponents["default"].div.withConfig({
  displayName: "ModalSuccessIcon",
  componentId: "sc-19910cc-5"
})(["display:flex;justify-content:center;align-items:center;margin-top:15%;margin-bottom:5%;"]);

exports.ModalSuccessIcon = ModalSuccessIcon;

var ModalSuccessMessage = _styledComponents["default"].div.withConfig({
  displayName: "ModalSuccessMessage",
  componentId: "sc-19910cc-6"
})(["display:flex;justify-content:center;align-items:center;font-family:Inter;font-style:normal;font-weight:normal;font-size:16px;color:#212121;margin-bottom:15%;"]);

exports.ModalSuccessMessage = ModalSuccessMessage;

var ModalContent = _styledComponents["default"].div.withConfig({
  displayName: "ModalContent",
  componentId: "sc-19910cc-7"
})(["", ";background-color:#ffffff;padding:30px 40px 25px;border-radius:4px;margin:100px auto;width:100%;transition:opacity 0.09s ease;position:relative;z-index:101;overflow:hidden;"], function (props) {
  return props.width ? "max-width: ".concat(props.width, "px") : null;
});

exports.ModalContent = ModalContent;

var CloseBtn = _styledComponents["default"].button.withConfig({
  displayName: "CloseBtn",
  componentId: "sc-19910cc-8"
})(["position:absolute;right:40px;top:30px;cursor:pointer;border:0;background-color:transparent;"]);

exports.CloseBtn = CloseBtn;